/** @format */

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ArticleIcon from '@mui/icons-material/Article';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import HistoryIcon from "@mui/icons-material/History";
import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface Props {
  setValue: React.Dispatch<React.SetStateAction<number>>;
  value: number;
}

export default function ViewAppTabs({ setValue, value }: Props) {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'>
          <Tab icon={<AccountBoxIcon/>} label='Personal Details' {...a11yProps(0)} />
          <Tab icon={<SchoolIcon/>} label='Institution' {...a11yProps(1)} />
          <Tab icon={<EscalatorWarningIcon/>} label='Legal Guardian' {...a11yProps(2)} />
          <Tab icon={<ArticleIcon/>} label='Documents' {...a11yProps(3)} />
          <Tab icon={<HistoryIcon />} label='Audits'   {...a11yProps(4)} />
          <Tab icon={<AccountBalanceWalletIcon />} label='Means Test'   {...a11yProps(4)} />
        </Tabs>
      </Box>
    </Box>
  );
}
